import { adminGymDeletionRequestSchema, type AdminGymDeletionRequest } from '@steado/admin-contract/gyms';
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';

import type { ApiClient } from '@/lib/api/client';

export const GYM_DELETIONS_KEY = ['admin', 'gym-deletion-requests'] as const;

/** The open account deletion requests, oldest first. */
export function openGymDeletionsQueryOptions(api: ApiClient) {
  return queryOptions({
    queryKey: [...GYM_DELETIONS_KEY, 'open'],
    queryFn: (): Promise<AdminGymDeletionRequest[]> =>
      api.request({
        path: '/admin/gym-deletion-requests',
        query: { status: 'open' },
        schema: z.array(adminGymDeletionRequestSchema),
      }),
  });
}

export function markGymDeletionDone(api: ApiClient, id: string): Promise<AdminGymDeletionRequest> {
  return api.request({
    path: `/admin/gym-deletion-requests/${id}/done`,
    method: 'POST',
    schema: adminGymDeletionRequestSchema,
  });
}
